import type { CaptureOptions, DomainEventName, ProductEvent, ProductEventName } from './events';
import type { LegacyParityEventName } from './legacy-parity';

export interface ProductAnalyticsTransport {
  track(
    event: ProductEventName | DomainEventName | LegacyParityEventName,
    properties: Record<string, unknown>,
    options?: CaptureOptions,
  ): void;
}

/** Emit a validated builder result without making apps repeat option handling. */
export function captureProductEvent(
  transport: ProductAnalyticsTransport,
  event: ProductEvent,
): void {
  if (event.options === undefined) {
    transport.track(event.event, event.properties);
    return;
  }
  transport.track(event.event, event.properties, event.options);
}
